module.exports = __webpack_public_path__ + "img/help8_ramamoorthy_paper.8609d04f.png";